export function mergeWithDefaults<T extends Record<string, any>>(defaults: T, stored: any): T {
  const result: any = { ...defaults };

  for (const key in defaults) {
    const defaultValue = defaults[key];
    const storedValue = stored?.[key];

    if (storedValue === undefined || storedValue === null) {
      result[key] = defaultValue;
      continue;
    }

    if (
      typeof defaultValue === 'object' &&
      !Array.isArray(defaultValue) &&
      typeof storedValue === 'object'
    ) {
      result[key] = mergeWithDefaults(defaultValue, storedValue);
      continue;
    }

    if (typeof storedValue === typeof defaultValue) {
      result[key] = storedValue;
    } else {
      result[key] = defaultValue;
    }
  }

  return result;
}
